// extracted by mini-css-extract-plugin
export default {"actionBtn":"index-module--actionBtn--f891e","guide":"index-module--guide--9d3f5","subtitle":"index-module--subtitle--b1843","logo":"index-module--logo--f14e6"};